'use client';

/* -------------------------------------------------------------------------- */
/*                                Dependencies                                */
/* -------------------------------------------------------------------------- */

// Lib dependencies
import times from 'lodash/times';

// UI lib components
import { Skeleton, Stack } from '@mantine/core';

// Types
import { ContentLoaderProps } from './types';

// Style
import * as classes from './styles/index.css';

/* -------------------------------------------------------------------------- */
/*                                  Component                                 */
/* -------------------------------------------------------------------------- */

function ContentLoader({
  withCircle = false,
  circleProps,
  containerProps,
  count = 1,
  secondaryWidth = '70%',
  ...props
}: ContentLoaderProps) {
  /* ********************************** HOOKS ********************************* */

  // Style

  /* ******************************** RENDERING ******************************* */
  return (
    <Stack gap="0.5rem" className={classes.contentLoader} {...containerProps}>
      {withCircle ? (
        <Skeleton height={50} circle mb="xl" {...circleProps} />
      ) : null}
      <Skeleton height={8} radius="xl" {...props} />
      <Skeleton height={8} radius="xl" {...props} />
      {times(count).map((i) => (
        <Skeleton
          key={i}
          height={8}
          width={secondaryWidth}
          radius="xl"
          {...props}
        />
      ))}
    </Stack>
  );
}

export default ContentLoader;
